import Axios from 'axios'
let axios = Axios.create()
let axiosRaw = Axios.create()

axios.interceptors.response.use((response)=>{
    if( response instanceof Error ){
        return Promise.reject(response.message)
    }else{
        return Promise.resolve(response.data)
    }
})

axiosRaw.interceptors.response.use((response)=>{
    if( response instanceof Error ){
        return Promise.reject(response)
    }else{
        return Promise.resolve(response)
    }
})

export default {
    birthday: {
        getBirthdayNotifications: () => 
            axios.get(`/api/birthday-notifications`),
        markAsViewed: () => 
            axios.post(`/api/birthday-notifications/visto`)
    }
}


// WEBPACK FOOTER //
// ./frontEnd/admin/Notificacion/services/services.js